var parent = require('../../stable/object/get-prototype-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/object/get-prototype-of.js
// module id = 495
// module chunks = 0 1